<template>
	<div class="information_list_item van-hairline--bottom" @click="clickItem">
		<div class="content">
			<h3 class="title van-multi-ellipsis--l2">{{ title }}</h3>
			<p class="date">{{ issueDate }}</p>
		</div>
		<div class="img" v-if="cover">
			<img :src="cover" alt="" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'InformationListItem',
		props: ['title', 'issueDate', 'cover'],
		methods: {
			clickItem () {
				this.$emit('click')
			}
		}
	}
</script>

<style scoped lang="less">
	.information_list_item {
		padding: 40px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.content {
			flex: auto;
			height: 160px;
			word-break: break-all;
			position: relative;
			.title {
				font-family: PingFangSC-Medium;
				font-size: 32px;
				font-weight: normal;
				color: #1F2329;
			}
			.date {
				position: absolute;
				bottom: 0;
				left: 0;
				font-family: PingFangSC-Regular;
				font-size: 22px;
				font-weight: normal;
				line-height: 26px;
				color: #999;
			}
		}
		.img {
			flex: 0 0 238px;
			text-align: right;
			>img {
				width: 210px;
				height: 160px;
				border-radius: 12px;
			}
		}
	}
</style>
